__turbopack_context__.v({
  "cardLink": "pJKXYa_cardLink",
  "readMore": "pJKXYa_readMore",
});
